export default "__VITE_ASSET__a29a25e1__"